<template>
  <span>
    <slot name="status" v-bind:item="item">
      <v-tooltip v-if="statusIndicator.tooltip" top>
        <template v-slot:activator="{ on }">
          <span class="wrapper" v-on="on">
            <v-btn
                :color="statusIndicator.color"
                text
                class="pa-0 disabled-events no-uppercase subtitle-2"
            >
            {{ statusIndicator.label }}
            <v-icon
                v-on="on"
                right
                class="mr-0"
            >
              {{ statusIndicator.icon }}
            </v-icon>
          </v-btn>
          </span>
        </template>
        <span>{{ statusIndicator.tooltip }}</span>
      </v-tooltip>
      <span v-else>{{ statusIndicator.label }}</span>
    </slot>
  </span>
</template>

<script>

import constants from '@/constants';

export default {
  name: 'ApprovalStatusTableCell',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusIndicator() {
      return this.getTimePairApprovalStatusIndicator(this.item);
    },
  },

  methods: {
    getTimePairApprovalStatusIndicator(timePair) {
      switch (timePair.status) {
        case constants.Approvals.Status.APPROVED: {
          return this.buildTooltip(
            timePair, 'check_circle_outline', `${constants.AppColors.SUCCESS} darken-1`,
          );
        }
        case constants.Approvals.Status.REJECTED: {
          return this.buildTooltip(timePair, 'cancel', `${constants.AppColors.ERROR} darken-1`);
        }
        case constants.Approvals.Status.PENDING_DELETE: {
          return this.buildTooltip(timePair, 'delete_outline', constants.AppColors.ERROR);
        }
        case constants.Approvals.Status.PENDING: {
          return this.buildTooltip(timePair, 'help_outline', constants.AppColors.WARN);
        }
        case constants.Approvals.Status.INCOMPLETE: {
          return this.buildTooltip(timePair, 'timelapse', '');
        }
        default: {
          return { label: this.$t('indicators.noStatus') };
        }
      }
    },

    buildTooltip(timePair, icon, color) {
      const tooltip = this.$t(`indicators.status.${timePair.status}`);

      return {
        icon, color, tooltip, label: this.$t(`status.${timePair.status}`),
      };
    },
  },
};
</script>

<style scoped>
.wrapper {
  cursor: pointer;
}

.disabled-events {
  pointer-events: none;
}

.no-uppercase {
  text-transform: none;
}
</style>
